import { Checkbox } from "antd";
import React, { useState } from "react";
import { convertUTCDateLocal } from "../../../../../utils/convertionFunc";

function AlertsTable({ data }) {
  return (
    <>
      <div className="w-full overflow-auto">
        <div
          className={`min-w-full ${
            data ? "w-max" : "w-full"
          } rounded-lg flex justify-center`}
        >
          <table className="w-full relative">
            <thead className="border rounded-lg">
              <tr>
                <th className="px-4">Date & Time</th>
                <th className="px-4">Subject</th>
                <th className="px-4">Content</th>
              </tr>
            </thead>
            <tbody className="">
              {data?.map((item, idx) => (
                <React.Fragment key={item.key || idx}>
                  <tr className="border-b">
                    <td className="px-4">{convertUTCDateLocal(item.date)}</td>
                    <td className="px-4">{item.subject}</td>
                    <td className="px-4 flex justify-start items-start">
                      <span>{item.content}</span>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default AlertsTable;
